import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, getRole } from "@/lib/auth";
import { toast } from "sonner";

export default function ProtectedRoute({ requiredRoles }) {
    if (!isAuthenticated()) return <Navigate to="/login" replace />;
    if (requiredRoles && requiredRoles.length > 0) {
        const role = getRole();
        if (!requiredRoles.includes(role)) {
            toast.error("Access denied: insufficient permissions");
            return <Navigate to="/" replace />;
        }
    }
    return <Outlet />;
}
